/*
 * 项目配置文件
 * 入口文件是index.[desktop|mobile|mcn|...].js文件
 *
 * @Author: jruif
 * @Date: 2017/8/10 下午8:50
 * */

import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import createHistory from 'history/createHashHistory';
import thunkMiddleware from 'redux-thunk';
// import registerServiceWorker from './registerServiceWorker';

export const history = createHistory();

// 构造redux的store
export default (reducer, initialState) => {
  return compose(
    applyMiddleware(
      routerMiddleware(history),
      thunkMiddleware.withExtraArgument({}), //添加额外参数
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  )(createStore)(reducer, initialState);
};
